import { safeGet } from '@mo/mo-safe-request';
import { apiUrl } from '../../../common/gateway';

import {
    AuthFailureResponse,
    AuthFlowState,
    AuthRedirectWithStatus,
    CheckUsernamePasswordRequest,
} from '../../../domain/AuthFlowState';

import axios, { AxiosError, AxiosResponse } from 'axios';
import { AccountLockedError, CredentialsMismatchError, ServiceUnavailableError, SessionExpiredError } from './errors';

const AuthFailureMessages = {
    CREDENTIALS_MISMATCH: 'The email and password that you entered do not match. Please review these and try again.',
    ACCOUNT_LOCKED: 'Your account is locked.',
    FIELD_REQUIRED: 'This field is required.',
};

export async function fetchPingAuthFlowState(flowId?: string): Promise<AuthFlowState> {
    flowId = !flowId || flowId === '' ? 'missing' : flowId; //if nothing is passed as a param, then express doesn't recognise its calling the bff
    return await safeGet(apiUrl(`auth/${flowId}`, 'v1'));
}

export async function checkUsernameAndPassword(
    body: CheckUsernamePasswordRequest,
    flowId: string
): Promise<AuthRedirectWithStatus> {
    return axios
        .post(apiUrl(`auth/${flowId}`, 'v1'), body)
        .then((response: AxiosResponse<AuthRedirectWithStatus>) => response.data)
        .catch((error: AxiosError<AuthFailureResponse>) => {
            const userMessage = error.response?.data.message?.details?.[0]?.userMessage;

            if (userMessage?.includes(AuthFailureMessages.FIELD_REQUIRED)) {
                throw new CredentialsMismatchError();
            }

            if (userMessage?.includes(AuthFailureMessages.CREDENTIALS_MISMATCH)) {
                throw new CredentialsMismatchError();
            }

            if (userMessage?.includes(AuthFailureMessages.ACCOUNT_LOCKED)) {
                throw new AccountLockedError();
            }

            if (error.response?.status === 404) {
                throw new SessionExpiredError();
            }

            if (error.response?.status === 502) { // Unknown user?
                throw new CredentialsMismatchError();
            }

            throw new ServiceUnavailableError();
        });
}